export class ActionLog {
    _id : string
    operator : string
    method : string
    url : string
    timeStamp : number
    ip : string
    time : Date
}